(() => {
  if (window.AurevonaCartDrawerLinksInitialized) return;
  window.AurevonaCartDrawerLinksInitialized = true;

  const isCartRouteLink = (element) => {
    if (!element || !window.routes?.cart_url) return false;
    try {
      const linkPath = new URL(element.href, window.location.origin).pathname.replace(/\/$/, '');
      const cartPath = new URL(window.routes.cart_url, window.location.origin).pathname.replace(/\/$/, '');
      return linkPath === cartPath;
    } catch (error) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    const explicitCartButton = event.target.closest('[data-aurevona-open-cart]');
    const linkedCartButton = event.target.closest('a[href]');
    const openCartButton = explicitCartButton || (isCartRouteLink(linkedCartButton) ? linkedCartButton : null);
    if (!openCartButton) return;

    event.preventDefault();
    const openDrawer = () => {
      const drawer = document.querySelector('cart-drawer.aurevona-cart');
      if (drawer && typeof drawer.open === 'function') drawer.open(openCartButton);
    };

    if (customElements.get('cart-drawer')) openDrawer();
    else customElements.whenDefined('cart-drawer').then(openDrawer);
  });

  const initCalmovaPayments = () => {
    const drawer = document.querySelector('cart-drawer.aurevona-cart--calmova');
    if (!drawer) return;

    const syncPayments = (force = false) => {
      // Section AJAX responses may omit the product object, and therefore omit
      // the Liquid data marker. The drawer's Calmova class survives the rerender.
      const target = drawer.querySelector('[data-avc-cart-payments]')
        || drawer.querySelector('.aurevona-cart__payments');
      if (!target || (target.dataset.avcPaymentsMirrored === 'true' && !force)) return;

      // Reuse exactly the payment display selected for the Calmova product page.
      // Keep the server-rendered enabled-payment icons as a fallback when no block exists.
      const sourceNodes = document.querySelectorAll(
        '#av-calmova-scope .avc-summary__payments, #av-calmova-scope .avc-summary__individual-payment',
      );
      if (!sourceNodes.length) return;

      const copies = Array.from(sourceNodes, (source) => {
        const copy = source.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        return copy;
      });
      target.replaceChildren(...copies);
      target.dataset.avcPaymentsMirrored = 'true';
    };

    syncPayments();
    new MutationObserver(() => syncPayments()).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => syncPayments(true));
  };

  const initCalmovaShipping = () => {
    const drawer = document.querySelector('cart-drawer.aurevona-cart--calmova');
    if (!drawer) return;

    const ensureShipping = () => {
      const header = drawer.querySelector('.aurevona-cart__header');
      if (!header) return null;

      // Quantity updates can fetch cart-drawer from /cart, where Liquid has no
      // product context. Restore only the Calmova header after that rerender.
      const heading = header.querySelector('.drawer__heading');
      if (heading && !heading.textContent.trim().startsWith('My Cart')) {
        const count = heading.textContent.match(/(\d+)\s*$/)?.[1] || '0';
        heading.textContent = `My Cart · ${count}`;
      }

      let shipping = drawer.querySelector('[data-avc-cart-shipping]');
      if (shipping) return shipping;

      shipping = document.createElement('div');
      shipping.className = 'aurevona-cart__shipping';
      shipping.dataset.avcCartShipping = '';
      shipping.innerHTML = `
        <strong class="aurevona-cart__shipping-label">Free Shipping Unlocked</strong>
        <div class="aurevona-cart__shipping-track" aria-hidden="true">
          <span class="aurevona-cart__shipping-fill" data-avc-cart-shipping-fill></span>
          <span class="aurevona-cart__shipping-truck">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">
              <path d="M3 6h11v10H3zM14 9h4l3 3v4h-7zM6.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
            </svg>
          </span>
        </div>`;
      header.insertAdjacentElement('afterend', shipping);
      return shipping;
    };

    ensureShipping();
    new MutationObserver(ensureShipping).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', ensureShipping);

    const attachAnimation = () => {
      if (typeof drawer.renderContents !== 'function' || drawer.dataset.avcShippingWrapped === 'true') return;
      const originalRenderContents = drawer.renderContents;
      drawer.renderContents = function (...args) {
        const result = originalRenderContents.apply(this, args);
        const shipping = ensureShipping();
        if (shipping && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          shipping.classList.remove('is-animating');
          // Reset the short animation so every successful add-to-cart can replay it.
          void shipping.offsetWidth;
          shipping.classList.add('is-animating');
        }
        return result;
      };
      drawer.dataset.avcShippingWrapped = 'true';
    };

    if (customElements.get('cart-drawer')) attachAnimation();
    else customElements.whenDefined('cart-drawer').then(attachAnimation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCalmovaPayments();
      initCalmovaShipping();
    }, { once: true });
  } else {
    initCalmovaPayments();
    initCalmovaShipping();
  }
})();
